import * as TYPES from './types'
import { getFormattedCalendarForDayOff } from '@/utils/day-off-calendar'
import axios from 'axios'

const createState = () => ({
  datesCalendar: {}
})

const getters = {
  datesCalendar (state) {
    return state.datesCalendar
  }
}

const actions = {
  async getDatesCalendar ({ commit }, year) {
    const currentYaer = year || new Date().getFullYear()
    commit(TYPES.SET_DATES_CALENDAR, {
      year: currentYaer,
      data: { list: [], isLoading: true }
    })
    let res = null
    try {
      const startDate = new Date(`${currentYaer}-01-01`).toISOString()
      const endDate = new Date(`${currentYaer}-12-31`).toISOString()

      const { data } = await axios({
        baseURL: __config.api_url,
        url: '/api/workdays/calendar',
        params: {
          start: startDate, end: endDate
        }
      })

      res = getFormattedCalendarForDayOff(data.data)
    } catch (err) {
      throw err
    }
    commit(TYPES.SET_DATES_CALENDAR, {
      year: currentYaer,
      data: {
        list: res,
        isLoading: false
      }
    })

    return res
  }
}

const mutations = {
  [TYPES.SET_DATES_CALENDAR] (state, { year, data }) {
    state.datesCalendar = {
      ...state.datesCalendar,
      [year]: {
        isLoading: data.isLoading,
        list: data.list
      }
    }
  }
}

export default {
  namespaced: true,
  state: createState,
  getters,
  actions,
  mutations
}
